import { render, staticRenderFns } from "./simOpenXy8.vue?vue&type=template&id=5438e19d&scoped=true&"
import script from "./simOpenXy8.vue?vue&type=script&lang=js&"
export * from "./simOpenXy8.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXy8.vue?vue&type=style&index=0&id=5438e19d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438e19d",
  null
  
)

export default component.exports